export function insertAnalyticsTags(google_id, pixel_id) {
	try {
		if (google_id && !window.gtag) { // Precisa verificar pra não prejudicar a sessão.
			// Cria e insere o script do GA
			const google_script = document.createElement('script');
			google_script.async = true;
			google_script.src = `https://www.googletagmanager.com/gtag/js?id=${google_id}`;
			document.head.appendChild(google_script);

			// Inicializa o gtag
			window.dataLayer = window.dataLayer || [];
			window.gtag = function () { dataLayer.push(arguments); };
			window.gtag('set', 'linker', { 'domains': ['*'] });
			window.gtag('js', new Date());
			window.gtag('config', google_id, { 'cookie_flags': 'samesite=none;secure' });

			const params = new URL(document.location.href).searchParams;
			if (params.get("GTAG")) {
				window.gtag('config', params.get("GTAG"), { 'cookie_flags': 'samesite=none;secure' });
			}
		}
		
		if (pixel_id) {
			const pixel_script = document.createElement('script');

			pixel_script.innerHTML = `
			!function(f,b,e,v,n,t,s)
			{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
			n.callMethod.apply(n,arguments):n.queue.push(arguments)};
			if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
			n.queue=[];t=b.createElement(e);t.async=!0;
			t.src=v;s=b.getElementsByTagName(e)[0];
			s.parentNode.insertBefore(t,s)}(window, document,'script',
			'https://connect.facebook.net/en_US/fbevents.js');
			fbq('init', '${pixel_id}');
			fbq('track', 'PageView');
		`;

			document.head.appendChild(pixel_script);
		}
	} catch (e) {
		console.error(e);
		return;
	}
}



// WEBPACK FOOTER //
// ./src/utils/analytics.js